<template lang="pug">
  #mobile-sections
    #mobile-menu
      MobileMenu
    #Allsections
      Section1
      Section2
      Section3
      Section4
      
</template>

<script>
import MobileMenu from "./MobileMenu.vue"
import Section1 from "./Section1.vue"
import Section2 from "./Section2.vue"
import Section3 from "./Section3.vue"
import Section4 from "./Section4.vue"

export default {
  name: "MobileSections",
  components: {
    MobileMenu,
    Section1,
    Section2,
    Section3,
    Section4
  }
}
</script>

<style lang="scss">
#mobile-sections {
  position: relative;
}
#mobile-menu {
  position: sticky;
  position: -webkit-sticky; /* Safari */
  top: 0px;
  z-index: 12;
  width: 100%;
  height: 89px;
  
}
</style>